import { useCallback, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { useAppSelector } from 'src/redux/hooks'
import { RootState } from 'src/redux/root'
import { uploadBaseGisFile } from 'src/redux/slices/umibuilder/endpoints'

import TextField from '@material-ui/core/TextField'

const editorProps = {
  accept:
    'application/zip, application/x-zip-compressed, multipart/x-zip, .umi, application/json, .json',
  maxFiles: 1,
}

type RtkDropzoneProps = {
  mutation: typeof uploadBaseGisFile.useMutation
  filenameSelector?: (index: number) => (state: RootState) => string
  rows?: number
  skipReset?: boolean
  index: string | number
  accept?: string
  maxFiles?: number
  selectedFilename?: string
  showBrowseButton?: boolean
  label: string
  formData?: Record<string, string>
}
export const RtkDropzone: React.FC<RtkDropzoneProps> = ({
  mutation,
  filenameSelector,
  rows,
  skipReset,
  index,
  accept,
  maxFiles,
  selectedFilename,
  showBrowseButton,
  label,
  formData,
}) => {
  const [trigger, { data, isLoading, isSuccess, isError, reset }] = mutation({
    fixedCacheKey: String(index),
  })
  const selectorFilename = useAppSelector(
    filenameSelector ? filenameSelector(Number(index)) : (state) => null,
  )
  const dataFilename = data?.filename // stored in json response

  useEffect(() => {
    if (skipReset) return
    reset()
  }, [skipReset])

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const data = new FormData()
      data.append('index', String(index))
      if (formData) {
        Object.entries(formData).forEach(([key, value]) => {
          data.append(key, value)
        })
      }

      acceptedFiles.forEach((file) => {
        data.append('file', file)
      })
      trigger({ index, body: data })
    },
    [trigger, index],
  )

  const { getRootProps, getInputProps, acceptedFiles, isDragActive } = useDropzone({
    accept:
      accept ??
      'application/zip, application/x-zip-compressed, multipart/x-zip, .umi, application/json, .json',
    maxFiles: maxFiles ?? 1,
    onDrop,
  })

  return (
    <div className='template-browser' {...getRootProps()}>
      {/* {(showBrowseButton || showBrowseButton === undefined) && <Button style={{marginRight: "2rem"}}className="template-browser-button" variant="outlined">Browse...</Button>} */}
      <TextField
        variant='outlined'
        label={label ?? 'Template Library'}
        value={
          dataFilename
            ? dataFilename
            : selectedFilename
            ? selectedFilename
            : selectorFilename
            ? selectorFilename
            : acceptedFiles.length > 0
            ? acceptedFiles.map((file) => file.name).join(',\n')
            : ''
        }
        InputProps={{
          readOnly: true,
        }}
        multiline={true}
        rows={rows}
        fullWidth={true}
        size='small'
        helperText="Click to upload or drag 'n' drop"
        error={isError ? true : undefined}
      />
      <input {...getInputProps()} />
    </div>
  )
}
